<template>
  <div>
    <div class="row">
      <div class="col-sm-6">
        <label for="">
          {{ $resourceString["contentWizard.Label.DocumentType"] }}
        </label>
        <div class="mb-2 justify-content-between align-items-center">
          <div class="input-group">
            <select @change="handleImageType" name="galleryImageType" class="form-control form-control-sm text-capitalize"
              :id="selectedOption" required="required" v-model="selectedOption">
              <option value="" :selected="true" disabled>
                {{ $resourceString["contentWizard.DocumentType.Dropdown.placeholder"] }}
              </option>
              <option v-for="(item, index) in getDocumentFilters" :key="index" :value="item">
                {{ item }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="pl-3 pt-3">
        <label for="">
          {{ $resourceString["contentWizard.Label.AddDocument"] }}
        </label>
      </div>
      <document-search :isDocument="true" :cols="'sm-12'"
        :placeholderName="$resourceString['contentWizard.Label.SearchFieldDocument.Placeholder']" />
    </div>
    <div class="d-flex justify-content-end pl-1 pr-2">
    </div>
    <div class="row mt-2" :class="getDocumentData.length > 3 ? 'inspiration-gallery-item-container pr-4' : ''"
      v-if="getDocumentData">
      <div class="row ml-1">
        <div
          class="col-3 px-1 pl-1 pr-1 mt-1 mb-1 document-default-width"
          v-for="(item, index) in getDocumentData" :key="index" v-if="item.title"
        >
          <button
            @click="updateImage(item)"
            type="button"
            class="btn wf-product-room-scene-color-item-button"
            :class="{
              'wf-product-room-scene-color-item-button-active': isSelected(
                item
              ),
              'wf-product-room-scene-color-item-button-disabled': !item.title
            }"
          >
            <div class="img" :style="(item.icon) ? '' : 'background-color: #ccc;'">
              <img :src="item.icon" alt="img" class="document-img" v-if="item.icon"/>
              <div class="document-img" v-else></div>
            </div>
            <div class="wf-product-room-scene-color-item-name document-title">
              <span class="document-item-title">
                {{ item.title }}
              </span>
            </div>
          </button>
        </div>
      </div>
      <pc-load-more v-if="showLoadMore" :load-more="onLoadMore" />
      <div v-if="getDocumentData.length == 0 && !showLoadMore" class="container">
        <p class="">{{ $resourceString["common.NoDataAvailable.Msg"] }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import PcLoadMore from "../../../common/pc-loading-more.vue";
import DocumentSearch from "./documentSearch.vue";

export default {
  data() {
    return {
      showClearIcon: false,
      selectedOption: '',
      initialDocumentData: [],
      selectedDocuments: [],
    }

  },
  components: {
    PcLoadMore,
    DocumentSearch
  },

  computed: {
    ...mapGetters({
      getDocumentData: "contentWizard/getDocumentData",
      showLoadMore: "contentWizard/getDocumentLoadMore",
      isFetching: "contentWizard/getLoader",
      getSelectedDocument: "contentWizard/getSelectedDocument",
      getDocumentFilters: "contentWizard/getDocumentFilters"
    }),

    areAllSelected() {
      return this.selectedDocuments?.length === this.getDocumentData?.length;
    }

  },

  created() {
    this.updateSelectedDocumentType()
  },

  mounted() {
    this.initialDocumentData = this.getDocumentData;
    const editedItem = this.getSelectedDocument;
    if (editedItem) {
      this.selectedDocuments = editedItem;
    }
  },

  watch: {
    selectedDocuments: {
      handler: function (newValue, oldValue) {
        this.setSelectedDocument(this.selectedDocuments);
      },
      deep: true
    }
  },
  methods: {
    ...mapActions({
      updateProductSearchTerm: "contentWizard/updateProductSearchTerm",
      loadMoreData: "contentWizard/loadMoreData",
      updateSelectedDocumentType: "contentWizard/updateSelectedDocumentType",
      setSelectedDocument: "contentWizard/setSelectedDocument",
      setContentItem: "contentWizard/setContentItem",
    }),
    onLoadMore() {
      if (this.isFetching) {
        return;
      }
      this.loadMoreData('document');
    },

    async updateSearchQuery(e) {
      await this.updateProductSearchTerm(e.target.value);
    },

    updateImage(data) {
      if (this.isSelected(data)) {
        this.selectedDocuments = this.selectedDocuments.filter(
          item => item.title !== data.title
        );
      } else {
        this.selectedDocuments.push({
          ...data
        });
      }
    },
    handleImageType() {
      this.updateSelectedDocumentType(this.selectedOption);
    },

    isSelected(data) {
      return this.selectedDocuments.some(
        item => item.title === data.title
      );
    },
    selectAll() {
      if (this.selectedDocuments.length === this.initialDocumentData.length) {
        this.selectedDocuments = [];
      } else {
        this.selectedDocuments = this.initialDocumentData
      }
    }
  }
};
</script>
